import { Route, Routes } from "react-router-dom";
import Home from "./website/Home";
import Waiting from "./website/Waiting";
import Faqs from "./website/Faqs";
import Careers from "./website/Careers";
import Policy from "./website/Policy";
import Terms from "./website/Terms";


function App() {
    return (
		<Routes>
			<Route path="/" element={<Home />} />
			<Route path="/waiting" element={<Waiting />} />
			<Route path="/faqs" element={<Faqs />} />
			<Route path="/careers" element={<Careers />} />
			<Route path="/privacy-policy" element={<Policy />} />
			<Route path="/terms-of-use" element={<Terms />} />
		</Routes>
    )
}

export default App;
